import { Component, OnInit, Input } from '@angular/core';
import { VehicleItem } from '../../../api/models/vehicle-item';
import { HeaderData } from '../../../api/models/header-data';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {

  @Input() headerData: HeaderData;
  @Input() vehicle: VehicleItem;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/page-header/page-header.component.ts